module.exports = __webpack_public_path__ + "img/bg_header_pixelfie.103ed937.jpg";